import { NgModule, ModuleWithProviders } from '@angular/core'
import { CommonModule } from '@angular/common'
import { IcosAlert } from './alert'


@NgModule({
  declarations: [IcosAlert],
  exports: [IcosAlert],
  imports: [CommonModule],
  entryComponents: [IcosAlert],
})
export class IcosAlertModule {
  static forRoot(): ModuleWithProviders {
    return { ngModule: IcosAlertModule, providers: [] }
  }
}
